/* 
  Usage:
  <ia-tabs-component class="ia-tabs">
    <div class="ia-tabs__header">
      <div class="ia-tab ia-tab--active" data-tab-index="0">Tab 1</div>
      <div class="ia-tab" data-tab-index="1">Tab 2</div>
    </div>
    <div class="ia-tabs__content">
      <div class="ia-tab-detail ia-tab-detail--active" data-detail-index="0">
        Content 1
      </div>
      <div class="ia-tab-detail" data-detail-index="1">
        Content 2
      </div>
    </div>
  </ia-tabs-component>
*/

if (!customElements.get('ia-tabs-component')) {
  class IaTabsComponent extends HTMLElement {
    connectedCallback() {
      const tabs = this.querySelectorAll('[data-tab-index]')
      const details = this.querySelectorAll('[data-detail-index]')

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          tabs.forEach((t) => {
            t.classList.remove('ia-tab--active')
            t.classList.remove('is-active')
          })
          details.forEach((d) => d.classList.remove('ia-tab-detail--active'))
          
          tab.classList.add('ia-tab--active')
          tab.classList.add('is-active')
          if (details[index]) {
            details[index].classList.add('ia-tab-detail--active')
          }
        })
      })
    }
  }

  customElements.define('ia-tabs-component', IaTabsComponent)
}
